// import {Locale} from 'vant'
//
// // todo 改为异步加载 优化app.js大小
// const langs = require.context('./langs', false, /\.js$/)
// const langs_vant = require.context('./vant', false, /\.ts$/)
//
// // 英语 阿拉伯 俄语 繁体中文 菲律宾语  韩语 日语 印地语 土耳其 越南  西班牙
// // en    ar   ru   tw      fil     kr  ja   hi    tr    vi   es
//
// const default_lang = 'en-US'
// //读取./langs/xxxx.js
// let messages = requireAll(langs)
// //读取./vant/xxxx.ts
// let messages_vant = requireAll(langs_vant)
//
// export function Locals(lang) {
//   console.log('Locale.use', lang)
//   Locale.use(lang, messages_vant[lang] || messages_vant[default_lang])
// }
//
// function requireAll(requireContext, secondPath) {
//   let messageMap = {}
//   requireContext.keys().forEach(importUrl => {
//     let langCode = importUrl.substring(2, importUrl.length - 3)
//     const jsonObject = requireContext(importUrl);
//     if (secondPath) {
//       let langObject = messageMap[langCode];
//       if (langObject == null) {
//         langObject = {}
//         messageMap[langCode] = langObject
//       }
//       langObject[secondPath] = jsonObject.default
//     } else {
//       messageMap[langCode] = jsonObject.default
//     }
//   })
//
//   //默认英文 一级的替换
//   for (let langCode of Object.keys(messageMap)) {
//     messageMap[langCode] = mergeDeep({}, messageMap[default_lang], messageMap[langCode])
//   }
//   return messageMap;
// }
//
// /**
//  * Simple object check.
//  * @param item
//  * @returns {boolean}
//  */
// export function isObject(item) {
//   return (item && typeof item === 'object' && !Array.isArray(item));
// }
//
// /**
//  * Deep merge two objects.
//  * @param target
//  * @param ...sources
//  */
// export function mergeDeep(target, ...sources) {
//   if (!sources.length) return target;
//   const source = sources.shift();
//
//   if (isObject(target) && isObject(source)) {
//     for (const key in source) {
//       if (isObject(source[key])) {
//         if (!target[key]) Object.assign(target, {[key]: {}});
//         mergeDeep(target[key], source[key]);
//       } else {
//         Object.assign(target, {[key]: source[key]});
//       }
//     }
//   }
//
//   return mergeDeep(target, ...sources);
// }
//
// export default messages
